import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hook/use-http";
import { Chart } from 'react-google-charts';
import NoData from '../../Driveanalysis/NoData';
import ChartLoader from '../../Driveanalysis/ChartLoader';
import BuketsTableVehicle from "../BuketsTableVehicle"
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let res_result
let Maxchartdata
let bartype
function MaxCoolentTempVehicle({ apiend, gloablfilter, type, chartSelectedBCS }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const [filteredDataOut, SetfilteredDataOut] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [chartname, SetChartName] = useState("Max coolant temp(oC) - Slow chrg");
  const [maxcoolenttype, setMaxType] = useState("Slow")
  let barcolor1
  let barcolor2
  let modal_title = "";
  let toPush = []
  let toPushOut = []
  let responce = []
  let responceout = []

  const appyData = (data) => {
    let dropdownname; 
    if(chartSelectedBCS === 'Max_BCS_Coolant_In'){
      dropdownname = 'Coolant_In_Temp'
    }else{
      dropdownname = 'Coolant_Out_Temp'
    }

    res_result = data;
    toPush = []
    toPushOut = []

    responceout = {
      "<24": 0,
      "26": 0,
      "28": 0,
      "30": 0,
      "32": 0,
      "34": 0,
      "36": 0,
      "38": 0,
      "40": 0,
      "42": 0,
      "44": 0,
      "46": 0,
      ">=46": 0,
    };

    if (res_result.length != 0) {

      if (res_result.length != 0) {
        SetApiResponce(res_result);

        let temp_result = res_result[0];
        let temp_resultout = res_result[0];

        if (temp_result[dropdownname + "less0_24"].value) {
          responceout["<24"] = temp_result[dropdownname + "less0_24"].value
        } if (temp_result[dropdownname + "24_26"].value) {
          responceout["26"] = temp_result[dropdownname + "24_26"].value
        } if (temp_result[dropdownname + "26_28"].value) {
          responceout["28"] = temp_result[dropdownname + "26_28"].value
        } if (temp_result[dropdownname + "28_30"].value) {
          responceout["30"] = temp_result[dropdownname + "28_30"].value
        } if (temp_result[dropdownname + "30_32"].value) {
          responceout["32"] = temp_result[dropdownname + "30_32"].value
        } if (temp_result[dropdownname + "32_34"].value) {
          responceout["34"] = temp_result[dropdownname + "32_34"].value
        } if (temp_result[dropdownname + "34_36"].value) {
          responceout["36"] = temp_result[dropdownname + "34_36"].value
        } if (temp_result[dropdownname + "36_38"].value) {
          responceout["38"] = temp_result[dropdownname + "36_38"].value
        } if (temp_result[dropdownname + "38_40"].value) {
          responceout["40"] = temp_result[dropdownname + "38_40"].value
        } if (temp_result[dropdownname + "40_42"].value) {
          responceout["42"] = temp_result[dropdownname + "40_42"].value
        } if (temp_result[dropdownname + "42_44"].value) {
          responceout["44"] = temp_result[dropdownname + "42_44"].value
        } if (temp_result[dropdownname + "44_46"].value) {
          responceout["46"] = temp_result[dropdownname + "44_46"].value
        } if (temp_result[dropdownname + "greater_46"].value) {
          responceout[">=46"] = temp_result[dropdownname + "greater_46"].value
        }

        toPushOut.push(temp_result[dropdownname + "less0_24"].value)
        toPushOut.push(temp_result[dropdownname + "24_26"].value)
        toPushOut.push(temp_result[dropdownname + "26_28"].value)
        toPushOut.push(temp_result[dropdownname + "28_30"].value)
        toPushOut.push(temp_result[dropdownname + "30_32"].value)
        toPushOut.push(temp_result[dropdownname + "32_34"].value)
        toPushOut.push(temp_result[dropdownname + "34_36"].value)
        toPushOut.push(temp_result[dropdownname + "36_38"].value)
        toPushOut.push(temp_result[dropdownname + "38_40"].value)
        toPushOut.push(temp_result[dropdownname + "40_42"].value)
        toPushOut.push(temp_result[dropdownname + "42_44"].value)
        toPushOut.push(temp_result[dropdownname + "44_46"].value)
        toPushOut.push(temp_result[dropdownname + "greater_46"].value)
        SetfilteredDataOut(toPushOut)

        let res_result_final = [["Element", "Count", { role: "style" }]]
        let loop_keys = Object.keys(responceout);


        loop_keys = ["<24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", "46", ">=46"]

        loop_keys.map(x => {
          // if (responceout[x]) {
            if(type === 'Slow'){
              res_result_final.push([x, responceout[x], `{stroke-width: 1;stroke-color: black;color:${"#348393"}}`]);
            }else{
              res_result_final.push([x, responceout[x], `{stroke-width: 1;stroke-color: black;color:${"#F39C48"}}`]);
            }
          }
        // }
      )
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }

      const labels = ["<24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", "46", ">=46"];
      Maxchartdata = {
        labels,
        datasets: [
          {
            label: chartSelectedBCS,
            data: responceout,
            backgroundColor: barcolor2,
            borderWidth: 1,
            borderColor: "black",
          }
        ]
      };
    }
  }
  let hAxis = {};

  if (apiend == "rangebarchart") {
    modal_title = "Real World Range Distribution";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Range (Km)',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const appyDataClick = (data) => {
    let hits = data;
    hits.map((i, key) => {
      toPush.push(i.fields[chartSelectedBCS][0])
    })
    SetfilteredData(toPush.sort())
  }

  if (apiend == "energybarchart") {
    modal_title = "Net Energy consumption";
    hAxis = {
      gridlines: {
        color: 'transparent'
      },
      title: 'Wh / Km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    };
  }

  const chartref = useRef()
  
  const options = {
    // borderColor: "black", // Border color for the bars
      // borderWidth: 2, 
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: chartSelectedBCS,
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };

  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          // text: 'Temperature (oC)'
          text: chartSelectedBCS
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycle'
        }
      },
    },

    plugins: {
      legend: {
        // position: "bottom"
        position: false
      },
    }
  };


  useEffect(() => {
    if (type === "Slow") {
      fetchData({ url: API_URL_MAIN + "chargingpage/" + apiend, body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max coolant temp(oC) - Slow chrg")
      setMaxType("Slow")
      barcolor1 = "#89CCD8";
      barcolor2 = "#348393"
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage/" + "maxcoolentvehiclelevelfast", body: { filterdata: gloablfilter } }, appyData)
      SetChartName("Max coolant temp(oC) - Fast chrg")
      setMaxType("Fast")
      barcolor1 = "#FFD1A4"
      barcolor2 = "#F39C48"
    }
  }, [gloablfilter, type, chartSelectedBCS])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: '400px' }}>
              {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Bar options={options1} data={Maxchartdata} width="100%" height="65px" /> :
                <NoData />

              )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>
      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length > 1) ? <Chart chartType="ColumnChart" options={options} data={chartdata} width="100%" height="230px" chartEvents={[
        {
          eventName: "select",
          callback({ chartWrapper }) {
            const chart = chartWrapper.getChart()
            const selection = chart.getSelection()
            const [selectedItem] = selection;
            const { row } = selectedItem;
            const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
            let from_bucket;
            let to_bucket;
            const count = chartWrapper.getDataTable().Wf[row].c[1].v;
            if (count !== 0) {
              if (barvalue === "<24") {
                from_bucket = 1
                to_bucket = 24
              } else if (barvalue === "<=46") {
                from_bucket = 44
                to_bucket = 46
              } else {
                from_bucket = barvalue - 2
                to_bucket = barvalue
              }
              if ( maxcoolenttype === "Slow" && chartSelectedBCS === "Max_BCS_Coolant_In") //bartype === 0 &&
                fetchData({ url: API_URL_MAIN + "chargingpage/maxcoolant_vehicle_click", body: { filterdata: gloablfilter, type: maxcoolenttype, to_coolant: chartSelectedBCS, from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              else if ( maxcoolenttype === "Slow" && chartSelectedBCS === "Max_BCS_Coolant_Out") //bartype === 1 &&
                fetchData({ url: API_URL_MAIN + "chargingpage/maxcoolant_vehicle_click_out", body: { filterdata: gloablfilter, type: maxcoolenttype, to_coolant: chartSelectedBCS, from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              else if ( maxcoolenttype === "Fast" && chartSelectedBCS === "Max_BCS_Coolant_In") //bartype === 0 &&
                fetchData({ url: API_URL_MAIN + "chargingpage/maxcoolant_vehicle_click", body: { filterdata: gloablfilter, type: maxcoolenttype, to_coolant: chartSelectedBCS, from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)
              else if ( maxcoolenttype === "Fast" && chartSelectedBCS === "Max_BCS_Coolant_Out") //bartype === 1 &&
                fetchData({ url: API_URL_MAIN + "chargingpage/maxcoolant_vehicle_click_out", body: { filterdata: gloablfilter, type: maxcoolenttype, to_coolant: chartSelectedBCS, from_bucket: parseInt(from_bucket), to_bucket: parseInt(to_bucket) } }, appyDataClick)

              window.$('#exampleModal__' + apiend).modal('show');
            }
          }
        }
      ]}
      /> : <NoData />
      )}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{chartname}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableVehicle data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MaxCoolentTempVehicle;